export function getLeadSourceIcon(name?: string | null): string {
  switch ((name ?? '').trim().toLowerCase()) {
    case 'facebook':
      return 'bi-facebook'
    case 'instagram':
      return 'bi-instagram'
    case 'google':
      return 'bi-google'
    case 'whatsapp':
      return 'bi-whatsapp'
    default:
      return ''
  }
}
